module.exports = __webpack_public_path__ + "static/bowling-1ed32320056eabcae94de3950c87b429.webp";